import colors from '../../_shared/colors';

export const global = `
  .ant-table-content td {
    font-size: 12px;
  }
`;

export const sbstyles = {
  iconMarg: `
    margin-right: 5px;
  `,
  button: `
    font-size: 11px;
    cursor: pointer;
    margin: 3px 0;
  `,
  infoDivide: `
    margin-bottom: 20px;
  `,
  motorItem: `
    margin-bottom: 10px;
  `,
  motorSwitch: `
    margin-left: 10px;
  `,
  serialItem: `
    margin-left: 10px;
    font-size: 11px;
  `,
};

export const modalStyles = {
  content: `
    font-size: 16px;
    font-weight: bold;
  `,
  dividers: `
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 20px;
  `,
  label: `
    font-weight: bold;
    font-size: 14px;
    width: 100px;
  `,
};

export default {
  icon: `
    color: ${colors.labelColor};
    font-size: 16px;
  `,
  deviceStatusAlertContainer: `
    margin-left: -20px;
    margin-top: -20px;
    width: calc(100% + 40px);
  `,
  deviceStatusAlert: `
    height: 30px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    color: ${colors.white};
    border-bottom: 1px solid ${colors.disabledLight};
  `,
  container: `
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    width: 100%;
    justify-content: flex-start;
    align-items: start;
    margin-bottom: -20px;
  `,
  sideMenu: `
    min-width: 200px;
    height: 100%;
    overflow: hidden;
    overflow-y: auto;

    img {
      width: 150px;
      margin-top: 20px;
    }

    p {
      margin: 0;
      font-size: 12px;
      margin-bottom: 2px;
    }
  `,
  mainContainer: `
    min-height: calc(100% + 38px);
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    padding: 20px;
    margin-right: -20px;  
    margin-top: -43px;  
    overflow: hidden;
    overflow-y: auto;
    border-left: 2px solid ${colors.inputBorder};
  `,
  mainContainerPB: `
    width: 100%;
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
  `,
  expandRow: `
    font-weight: bold;
  `,
  hr: `
    width: 95%;
    height: 2px;
    margin-top: 20px;
    margin-bottom: 20px;
    border-bottom: 2px solid ${colors.inputBorder};
  `,
  hrMain: `
    width: calc(100% + 60px);
    height: 2px;
    margin-left: -20px;
    margin-top: 20px;
    margin-bottom: 20px;
    background-color: ${colors.inputBorder};
  `,
  minText: `
    display: flex;
    align-self: flex-end;
    color: ${colors.labelColor};
    font-size: 8px;
  `,
  smallText: `
    display: flex;
    align-self: flex-end;
    color: ${colors.labelColor};
    font-size: 10px;
  `,
  mediumText: `
    display: flex;
    align-self: flex-end;
    color: ${colors.labelColor};
    font-size: 16px;
  `,
  largeText: `
    color: ${colors.labelColor};
    font-size: 24px;
    margin-right: 2px;
  `,
  suffix: `
    margin-bottom: 7px;
  `,
  suffixIcon: `
    margin-bottom: 9px;
  `,
  title: `
    font-size: 13px;
    font-weight: bold;
    margin-right: 20px;
  `,
  date: `
    font-size: 10px;
    color: ${colors.lightText};
  `,
  overflowHidden: `
    overflow: hidden;
  `,
  showMore: `
    margin-top: 10px; 
    margin-left: 5px;
  `,
  blankMessage: `
    font-style: italic;
    font-size: 12px;
    margin-top: 15px;
  `,
  rightLink: `
    margin-left: auto;
  `,
  link: `
    background-color: transparent;
    border-color: transparent;
    color: ${colors.highlight};
    cursor: pointer;
  `,
  info: `
    font-style: italic;
  `,
  cancelLink: `
    font-style: italic;
    font-size: 12px;
  `,
  billingHistorySidebarLink: `
    font-style: italic;
  `,
  error: `
    font-size: 12px;
    color: ${colors.error};
  `,
  /* AER-1591: actions row above the top card on mobile — Get Latest Data
     on the left, "Online" status + switch on the right. Sits inside the
     parent's 20px padding (NOT edge-to-edge) per Ted's mock. */
  mobileActionsRow: `
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;
    width: 100%;
  `,
  mobileStatusGroup: `
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    margin-left: auto;
  `,
  mobileStatusText: `
    font-size: 14px;
    color: ${colors.black};
  `,
  /* AER-1591: mobile top "model card" replacing the standalone ModelImage.
     Image on the left (~30% of card), text column on the right with SN
     (bold), Model, Install Date and Service Due rows. Rounded corners +
     light border, fills the full content width inside the parent's 20px
     padding (per Ted's mock — the card stretches edge-to-edge of the
     content area, not just hugging its content). */
  mobileTopCard: `
    display: flex;
    flex-direction: row;
    align-items: stretch;
    width: 100%;
    box-sizing: border-box;
    border: 1px solid ${colors.inputBorder};
    border-radius: 10px;
    padding: 8px 10px;
    margin-bottom: 14px;
    background: ${colors.white};
  `,
  /* AER-1591: image column hosts the model picture and the right-edge
     separator line (Figma node 491:642 — a 1px vertical rule between the
     image and the info column). The shared ModelImage component wraps the
     <img> and only sets max-height; without an explicit width constraint
     on the img the natural image overflows this 30% column, so we add
     one in the nested selector and clip with overflow:hidden. */
  mobileTopCardImage: `
    width: 30%;
    max-width: 130px;
    height: 100px;
    flex-shrink: 0;
    align-self: center;
    padding-right: 12px;
    border-right: 1px solid ${colors.inputBorder};
    box-sizing: border-box;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  `,
  mobileTopCardInfo: `
    flex: 1 1 auto;
    margin-left: 14px;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
  `,
  mobileTopCardSN: `
    font-size: 16px;
    font-weight: bold;
    color: ${colors.black};
    overflow-wrap: break-word;
    word-break: break-word;
  `,
  mobileTopCardRow: `
    font-size: 13px;
    line-height: 1.35;
    margin: 0;
    overflow-wrap: break-word;
    word-break: break-word;
  `,
  mobileTopCardLabel: `
    color: ${colors.labelColor};
  `,
  mobileTopCardValue: `
    color: ${colors.black};
    font-weight: 500;
  `,
  mobileTopCardOverdue: `
    color: ${colors.error};
    font-weight: 500;
  `,
  /* AER-1591: location row beneath the top card. Pin icon on the left,
     two-line stack on the right (location name on top, address below). DO
     name is intentionally omitted per Ted's spec. */
  mobileLocationRow: `
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    margin-bottom: 14px;
    gap: 12px;
  `,
  mobileLocationIcon: `
    color: ${colors.labelColor};
    font-size: 28px;
    flex-shrink: 0;
    margin-top: 2px;
  `,
  mobileLocationText: `
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
    overflow-wrap: break-word;
    word-break: break-word;
  `,
  mobileLocationName: `
    font-size: 16px;
    color: ${colors.black};
    line-height: 1.35;
  `,
  mobileLocationAddress: `
    font-size: 16px;
    color: ${colors.black};
    line-height: 1.35;
  `,
  /* AER-1591: section header rule shared by Performance, Active Alerts,
     Maintenance Alerts and Service Records. Matches Ted's mock: bold,
     inherited font-size, no underline, sitting at the parent's natural
     left indent (NOT extended). Display: flex so the chevron + the
     Service Records "+" button align to the right. */
  mobileSectionHeader: `
    font-weight: bold;
    padding: 5px 0;
    width: 100%;
    display: flex;
    align-items: center;
    color: ${colors.black};
  `,
  mobileSectionChevron: `
    margin-left: auto;
    color: ${colors.labelColor};
    font-size: 14px;
  `,
  /* AER-1591: Active Alerts mobile cards. Color-coded major/minor triangle
     on the left (per Bruce's spec — Ted's mock had it on the right), name
     bold + message + date stacked. Purple close-circle floats top-right
     for clearable minor alerts. */
  mobileAlertCard: `
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    border: 1px solid ${colors.inputBorder};
    border-radius: 10px;
    padding: 12px;
    margin-bottom: 10px;
    background: ${colors.white};
    cursor: pointer;
  `,
  mobileAlertCardIcon: `
    font-size: 22px;
    flex-shrink: 0;
    margin-right: 12px;
    margin-top: 2px;
  `,
  mobileAlertCardContent: `
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
    overflow-wrap: break-word;
    word-break: break-word;
  `,
  mobileAlertCardTitle: `
    font-weight: bold;
    font-size: 14px;
    color: ${colors.black};
    line-height: 1.35;
  `,
  mobileAlertCardMessage: `
    font-size: 14px;
    color: ${colors.black};
    line-height: 1.35;
  `,
  mobileAlertCardDate: `
    font-size: 13px;
    color: ${colors.labelColor};
    margin-top: 2px;
  `,
  mobileAlertCardClear: `
    font-size: 18px;
    color: ${colors.highlight};
    margin-left: 8px;
    flex-shrink: 0;
  `,
  /* AER-1591: maintenance reminder card rows.
     Layout: bold component name (uses mobileAlertCardTitle),
     then "Last Serviced: <date>" (label grey, value black),
     then either "Service Overdue" (red) or "X hours remaining". */
  mobileMaintRow: `
    font-size: 14px;
    line-height: 1.35;
    margin: 0;
  `,
  mobileMaintLabel: `
    color: ${colors.labelColor};
  `,
  mobileMaintValue: `
    color: ${colors.black};
  `,
  /* AER-1591: Service Records mobile two-column table.
     Header row + alternating-background data rows (Figma 491:687/688 use
     a light-blue tint for the alternating fill). */
  mobileServicePlusBtn: `
    margin-left: auto;
    margin-right: 12px;
    color: ${colors.highlight};
    font-size: 22px;
    cursor: pointer;
  `,
  mobileServiceTable: `
    width: 100%;
    margin-top: 4px;
  `,
  mobileServiceHeaderRow: `
    display: flex;
    flex-direction: row;
    padding: 8px 12px;
    font-weight: bold;
    font-size: 14px;
    color: ${colors.black};
  `,
  mobileServiceHeaderCell: `
    flex: 1 1 auto;
  `,
  mobileServiceRow: `
    display: flex;
    flex-direction: row;
    padding: 10px 12px;
    font-size: 14px;
    color: ${colors.black};
    cursor: pointer;
  `,
  mobileServiceRowAlt: `
    background-color: #e8f3fb;
  `,
  mobileServiceCell: `
    flex: 1 1 auto;
  `,
  mobileServiceCellDate: `
    flex: 0 0 50%;
  `,
};
